import React from 'react';
import { motion } from 'framer-motion';
import { UserIcon, BriefcaseIcon, HeartIcon } from 'lucide-react';
const AboutMe = () => {
  return <motion.section initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    delay: 0.4
  }} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-30">
      <div className="bg-white/80 backdrop-blur-xl rounded-3xl p-8 md:p-12 shadow-sm border border-gray-100/20" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} className="grid md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-32">
          <div className="space-y-6" data-id="element-33">
            <motion.div whileHover={{
            scale: 1.02
          }} className="relative w-full aspect-square rounded-3xl overflow-hidden shadow-[0_20px_40px_-15px_rgba(0,0,0,0.1)] transition-shadow duration-300 hover:shadow-[0_25px_45px_-15px_rgba(0,0,0,0.15)]" data-id="element-34">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2C2uuJezCYpkGY57ZjYWJY/Nick_mit_Hintergrund.jpg" alt="Profile" className="w-full h-full object-cover transform transition-transform duration-700 hover:scale-105" data-id="element-35" />
            </motion.div>
          </div>
          <div className="space-y-8" data-id="element-36">
            <div data-id="element-37">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-38">
                Über mich
              </h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-39">
                Hey, ich bin Nick, 24 Jahre alt und leidenschaftlicher Videograf
                aus Bonn. Schon seit meiner Kindheit faszinieren mich Kameras –
                die Möglichkeit, Momente festzuhalten und Geschichten zu
                erzählen, treibt mich an. Egal ob Kurzfilm, Musikvideo oder
                animierte Werbeclips – ich liebe es, kreative Konzepte visuell
                umzusetzen. Mein Fokus liegt darauf, Emotionen und Botschaften
                durch modernes Storytelling und durchdachte Bildästhetik zum
                Leben zu erwecken.
              </p>
            </div>
            <div className="space-y-4" data-id="element-40">
              {[{
              icon: <UserIcon className="w-5 h-5" data-id="element-41" />,
              title: 'Experience',
              description: '8+ Jahre in digitaler Medienproduktion'
            }, {
              icon: <BriefcaseIcon className="w-5 h-5" data-id="element-42" />,
              title: 'Projects',
              description: '50+ abgeschlossene Projekte'
            }, {
              icon: <HeartIcon className="w-5 h-5" data-id="element-43" />,
              title: 'Passion',
              description: 'Geschichten erzählen, Motion Design und Kameraführung'
            }].map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.8 + index * 0.1
            }} className="flex items-center space-x-4 p-4 rounded-2xl hover:bg-gray-50/50 transition-colors duration-300" data-id="element-44">
                  <div className="flex-shrink-0 p-2 rounded-xl bg-gray-50" data-id="element-45">
                    {item.icon}
                  </div>
                  <div data-id="element-46">
                    <h3 className="font-medium text-gray-900" data-id="element-47">{item.title}</h3>
                    <p className="text-sm text-gray-600" data-id="element-48">{item.description}</p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </motion.section>;
};
export default AboutMe;